module.exports = __webpack_public_path__ + "img/Newsletter_Search_Arrow.12a8344.svg";